import React, { Component } from "react";
import Pagination from "../../shared/items/contols/pagination";

class MessagesTablePaginationControl extends Component {
  constructor(props) {
    super(props);

    this.state = {
      data: props.data,
      numShow: 20,
    };
  }

  render() {
    const { totalCount, count, page, onChangeStore } = this.props;

    return (
      <Pagination
        totalCount={totalCount}
        count={count}
        page={page}
        pageRangeDisplayed={25}
        onHandleChangeStore={onChangeStore}
      />
    );
  }
}

export default MessagesTablePaginationControl;
